import { render } from "./FormFile.vue?vue&type=template&id=07f77210"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07f77210"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07f77210', __exports__)) {
    console.log('reload')
    api.reload('07f77210', __exports__)
  }
  
  module.hot.accept("./FormFile.vue?vue&type=template&id=07f77210", () => {
    console.log('re-render')
    api.rerender('07f77210', render)
  })

}


export default __exports__